import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';
import styled from 'styled-components';

import * as graphql from '@treams/treams-network';
import { Button, Heading, Paragraph, tokens } from '@treams/treams-ui';

import Preview from './Preview';

const Main = styled(Box)`
	border-right: 1px solid ${tokens.border.subtle};
`;

const Detail = styled(Box)`
	transition: 0.4s cubic-bezier(0, 1, 0, 1) max-width;
`;

export default function Confirm(props: {
	group: graphql.Group;
	single?: boolean;
	recursive?: boolean;
	onSelect: (recursive: boolean) => void;
	onDeselect: () => void;
}) {
	const { t } = useTranslation();

	const [mounted, setMounted] = useState(false);

	useEffect(() => {
		setTimeout(() => setMounted(true), 200);
	}, []);

	return (
		<Flex>
			{!props.single && (
				<Main p={3} width={280}>
					<Heading mb={1}>{t('groups.selector.delete.title')}</Heading>
					{props.recursive ? (
						<>
							<Paragraph>{t('groups.selector.delete.parent.description')}</Paragraph>
							<Box mt={3}>
								<Button
									title={t('groups.selector.delete.parent.underlying')}
									type="secondary"
									onClick={() => props.onSelect(false)}
								/>
								<Button
									type="destructive"
									title={t('groups.selector.delete.parent.only')}
									mt={2}
									onClick={() => props.onDeselect()}
								/>
							</Box>
						</>
					) : (
						<>
							<Paragraph>{t('groups.selector.delete.child.description')}</Paragraph>
							<Button
								type="destructive"
								title={t('groups.selector.delete.child.only')}
								mt={3}
								onClick={() => props.onDeselect()}
							/>
						</>
					)}
				</Main>
			)}
			<Detail maxWidth={props.single ? 300 : mounted ? 240 : 0}>
				<Box width={props.single ? 300 : 240}>
					<Preview group={props.group} />
				</Box>
			</Detail>
		</Flex>
	);
}
